import { useEffect } from 'react';

const remembered = new Map();
const contextualRoutes = new Set(['/app/artist', '/calendar', '/app/artist/services', '/app/artist/materials', '/app/artist/clients']);

export function professionalServiceScope({workspace, user, studio}) {
  const studioId = studio?.id || user?.studio_id;
  return workspace?.role === 'artist' && user?.id && studioId
    ? `tps:professional-service:v1:${JSON.stringify([studioId, user.id, workspace.artist_profile_id || ''])}` : null;
}

function read(scope) {
  if (!scope) return null;
  try { return window.sessionStorage.getItem(scope) || remembered.get(scope); }
  catch { return remembered.get(scope); }
}

export function resolveProfessionalService(workspace, search, saved) {
  if (workspace?.role !== 'artist') return null;
  const types = workspace.service_types?.length ? workspace.service_types : ['tattoo'];
  const requested = new URLSearchParams(search).get('service_type');
  return [requested, saved, workspace.primary_service_type, types[0]].find(type => types.includes(type));
}

// Selection is scoped to this tab, Studio and professional. The URL can still
// open an explicit service (including notification links); stale permissions cannot persist.
export default function useProfessionalService(auth, search) {
  const scope = professionalServiceScope(auth);
  const service = resolveProfessionalService(auth.workspace, search, read(scope));
  useEffect(() => {
    if (!scope || !service) return;
    remembered.set(scope, service);
    try { window.sessionStorage.setItem(scope, service); } catch { /* Private/storage-disabled browsers retain it in memory. */ }
  }, [scope, service]);
  return service;
}

export function professionalServiceRoute(to, service) {
  if (!service) return to;
  const [address, hash] = to.split('#');
  const [pathname, search] = address.split('?');
  if (!contextualRoutes.has(pathname)) return to;
  const query = new URLSearchParams(search);
  if (!query.has('service_type')) query.set('service_type', service);
  return `${pathname}?${query}${hash === undefined ? '' : `#${hash}`}`;
}
